module.exports = __webpack_public_path__ + "media/newstyle/images/first-circle-db93bc1f0f6b9100af68163b721e945a.svg";